import { useEffect } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Drawer from "@mui/material/Drawer";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { NavSectionVertical } from "../../components/layout-components/nav-section";

import { NAV } from "../config-layout";
import { useNavData } from "./config-navigation";
import NavToggleButton from "../common/nav-toggle-button";
//import Logo from "../../modules/auth/pages/Logo";
import Scrollbar from "../../components/layout-components/scrollbar";
import { useResponsive } from "../../hooks/useResponsive";
import { usePathname } from "../../hooks/usePathName";
import Searchbar from "../common/searchbar";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { user } = {
    user: {
      role: "admin",
    },
  };

  const pathname = usePathname();
  const theme = useTheme();
  const lgUp = useResponsive("up", "lg");
  const isTabletDown = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navData = useNavData();
  const navWidth = isMobile ? "min(100vw - 16px, 248px)" : isTabletDown ? "min(100vw - 24px, 264px)" : `${NAV.W_VERTICAL}px`;

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        overflowX: "hidden",
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
        },
      }}
    >
      {/* <Logo sx={{ mt: 3, ml: 4, mb: 1 }} /> */}
      <img
        style={{
          margin: isMobile ? "20px auto 12px" : isTabletDown ? "24px auto 16px" : "40px auto 20px",
          width: isMobile ? 120 : isTabletDown ? 132 : 148,
          maxWidth: "calc(100% - 32px)",
          display: "block",
        }}
        src="/assets/background/bizmed-logo.png"
        alt="bizmed"
      />

      <Stack
        sx={{ px: isMobile ? 1 : 2, pb: isMobile ? 1 : 0 }}
        justifyContent="center"
        alignItems="stretch"
      >
        {" "}
        <Searchbar />
      </Stack>
      {/* center  */}
      {/*
      <ByzMuiButton variant="contained" color="primary" onClick={() => {console.log("clicked")}} link="/admin/tools" fullWidth>
        Admin Araçları
      </ByzMuiButton>
 center  */}
      <NavSectionVertical
        data={navData}
        slotProps={{
          currentRole: user?.role,
        }}
      />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_VERTICAL },
        minWidth: 0,
      }}
    >
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: "fixed",
            width: NAV.W_VERTICAL,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
            overflowX: "hidden",
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          sx={{
            width: navWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: navWidth,
              maxWidth: "calc(100vw - 8px)",
              overflowX: "hidden",
            },
          }}
          open={openNav}
          onClose={() => {
            onCloseNav();
          }}
          PaperProps={{
            sx: {
              width: navWidth,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
